document.addEventListener('DOMContentLoaded', function () {
  const browsers = document.querySelectorAll('[data-equipment-browser]');

  browsers.forEach((root) => {
    const cards = Array.from(root.querySelectorAll('[data-card]'));
    const resultsText = root.querySelector('[data-results-text]');
    const paginationWrap = root.querySelector('[data-pagination]');
    const categoryButtons = Array.from(root.querySelectorAll('[data-category-list] [data-category]'));
    const subcategoryButtons = Array.from(root.querySelectorAll('[data-subcategory-list] [data-subcategory]'));
    const fuelButtons = Array.from(root.querySelectorAll('[data-fuel-list] [data-fuel]'));
    const activeFilterLink = root.querySelector('[data-active-filter-link]');
    const perPage = parseInt(root.dataset.perPage || '9', 10);

    const subcategoryList = root.querySelector('[data-subcategory-list]');
    const subcategoryBlock = subcategoryList ? subcategoryList.closest('.equipment-sidebar__block') : null;

    let state = {
      category: 'all',
      categoryKey: 'all',
      subcategory: 'all',
      fuel: 'all',
      page: 1
    };

    const wishlistKey = 'equipmentWishlist';
    const compareKey = 'equipmentCompare';

    const compareWidget = root.querySelector('[data-compare-widget]');
    const compareDrawer = root.querySelector('[data-compare-drawer]');
    const compareModal = root.querySelector('[data-compare-modal]');
    const compareList = root.querySelector('[data-compare-list]');
    const compareTableWrap = root.querySelector('[data-compare-table-wrap]');
    const compareCount = root.querySelector('[data-compare-count]');
    const compareCountDrawer = root.querySelector('[data-compare-count-drawer]');
    const compareNowBtn = root.querySelector('[data-compare-now]');
    const compareNote = root.querySelector('[data-compare-note]');
    const compareTrigger = root.querySelector('[data-compare-trigger]');
    const compareClear = root.querySelector('[data-compare-clear]');

    function normalize(value) {
      return (value || '').toString().trim().toLowerCase();
    }

    function getStored(key) {
      try {
        return JSON.parse(localStorage.getItem(key)) || [];
      } catch (e) {
        return [];
      }
    }

    function setStored(key, value) {
      localStorage.setItem(key, JSON.stringify(value));
    }

    function setActive(buttons, activeValue, attrName) {
      buttons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.getAttribute(attrName) === activeValue);
      });
    }

    function setActiveSubcategory(activeValue) {
      subcategoryButtons.forEach((btn) => {
        const isAllButton = btn.getAttribute('data-subcategory') === 'all';
        const hiddenByCategory = btn.classList.contains('is-hidden-by-category');
        const matchesValue = btn.getAttribute('data-subcategory') === activeValue;

        if (activeValue === 'all') {
          btn.classList.toggle('is-active', isAllButton);
          return;
        }

        btn.classList.toggle('is-active', matchesValue && !hiddenByCategory);
      });
    }

    function toggleSubcategoryBlock() {
      if (!subcategoryBlock) return;

      if (state.categoryKey === 'all') {
        subcategoryBlock.style.display = 'none';
      } else {
        subcategoryBlock.style.display = '';
      }
    }

    function updateVisibleSubcategories() {
      toggleSubcategoryBlock();

      subcategoryButtons.forEach((btn) => {
        const parentKeysAttr = btn.getAttribute('data-parent-category-keys') || 'all';

        if (parentKeysAttr === 'all') {
          btn.classList.remove('is-hidden-by-category');
          return;
        }

        const parentKeys = parentKeysAttr.split('|').filter(Boolean);
        const shouldShow = state.categoryKey === 'all' || parentKeys.includes(state.categoryKey);

        btn.classList.toggle('is-hidden-by-category', !shouldShow);
      });

      if (state.categoryKey !== 'all' && state.subcategory !== 'all') {
        const activeSubBtn = subcategoryButtons.find((btn) => {
          return (
            btn.getAttribute('data-subcategory') === state.subcategory &&
            !btn.classList.contains('is-hidden-by-category')
          );
        });

        if (!activeSubBtn) {
          state.subcategory = 'all';
        }
      }

      setActiveSubcategory(state.subcategory);
    }

    function matchesFuel(cardFuel, selectedFuel) {
      if (selectedFuel === 'all') return true;

      const normalizedFuel = normalize(cardFuel);
      if (!normalizedFuel) return false;

      const parts = normalizedFuel
        .split(',')
        .map((item) => normalize(item))
        .filter(Boolean);

      return parts.includes(normalize(selectedFuel));
    }

    function getFilteredCards() {
      return cards.filter((card) => {
        const cardCategory = card.dataset.category;
        const cardSubcategory = card.dataset.subcategory;
        const cardFuel = card.dataset.fuel;

        const categoryMatch =
          state.category === 'all' || normalize(cardCategory) === normalize(state.category);

        const subcategoryMatch =
          state.subcategory === 'all' || normalize(cardSubcategory) === normalize(state.subcategory);

        const fuelMatch = matchesFuel(cardFuel, state.fuel);

        return categoryMatch && subcategoryMatch && fuelMatch;
      });
    }

    function buildShareUrl() {
      const url = new URL(window.location.href);

      url.searchParams.delete('category');
      url.searchParams.delete('subcategory');
      url.searchParams.delete('fuel');
      url.searchParams.delete('page');

      if (state.category !== 'all') {
        url.searchParams.set('category', state.category);
      }

      if (state.subcategory !== 'all') {
        url.searchParams.set('subcategory', state.subcategory);
      }

      if (state.fuel !== 'all') {
        url.searchParams.set('fuel', state.fuel);
      }

      if (state.page > 1) {
        url.searchParams.set('page', String(state.page));
      }

      return url;
    }

    function updateUrl() {
      const url = buildShareUrl();
      window.history.replaceState({}, '', url.toString());
    }

    function updateActiveFilterLink() {
      if (!activeFilterLink) return;

      const hasFilters =
        state.category !== 'all' ||
        state.subcategory !== 'all' ||
        state.fuel !== 'all' ||
        state.page > 1;

      if (!hasFilters) {
        activeFilterLink.hidden = true;
        activeFilterLink.removeAttribute('href');
        return;
      }

      activeFilterLink.hidden = false;
      activeFilterLink.href = buildShareUrl().toString();
    }

    function applyStateFromUrl() {
      const url = new URL(window.location.href);

      const category = url.searchParams.get('category');
      const subcategory = url.searchParams.get('subcategory');
      const fuel = url.searchParams.get('fuel');
      const page = parseInt(url.searchParams.get('page') || '1', 10);

      if (category) {
        const matchingCategory = categoryButtons.find(
          (btn) => normalize(btn.getAttribute('data-category')) === normalize(category)
        );

        if (matchingCategory) {
          state.category = matchingCategory.getAttribute('data-category');
          state.categoryKey = matchingCategory.getAttribute('data-category-key') || 'all';
        }
      }

      if (fuel) {
        const matchingFuel = fuelButtons.find(
          (btn) => normalize(btn.getAttribute('data-fuel')) === normalize(fuel)
        );

        if (matchingFuel) {
          state.fuel = matchingFuel.getAttribute('data-fuel');
        }
      }

      updateVisibleSubcategories();

      if (subcategory) {
        const matchingSubcategory = subcategoryButtons.find((btn) => {
          return (
            normalize(btn.getAttribute('data-subcategory')) === normalize(subcategory) &&
            !btn.classList.contains('is-hidden-by-category')
          );
        });

        if (matchingSubcategory) {
          state.subcategory = matchingSubcategory.getAttribute('data-subcategory');
        }
      }

      if (!Number.isNaN(page) && page > 0) {
        state.page = page;
      }

      setActive(categoryButtons, state.category, 'data-category');
      setActiveSubcategory(state.subcategory);
      setActive(fuelButtons, state.fuel, 'data-fuel');
    }

    function renderPagination(totalItems) {
      if (!paginationWrap) return;

      paginationWrap.innerHTML = '';
      const totalPages = Math.ceil(totalItems / perPage);

      if (totalPages <= 1) return;

      const prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'equipment-page-btn';
      prevBtn.textContent = 'Previous';
      prevBtn.disabled = state.page === 1;
      prevBtn.addEventListener('click', () => {
        if (state.page > 1) {
          state.page--;
          render();
        }
      });
      paginationWrap.appendChild(prevBtn);

      let startPage = Math.max(1, state.page - 2);
      let endPage = startPage + 5;

      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(1, endPage - 5);
      }

      for (let i = startPage; i <= endPage; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'equipment-page-btn' + (i === state.page ? ' is-active' : '');
        btn.textContent = i;
        btn.addEventListener('click', () => {
          state.page = i;
          render();
        });
        paginationWrap.appendChild(btn);
      }

      const nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'equipment-page-btn';
      nextBtn.textContent = 'Next';
      nextBtn.disabled = state.page === totalPages;
      nextBtn.addEventListener('click', () => {
        if (state.page < totalPages) {
          state.page++;
          render();
        }
      });
      paginationWrap.appendChild(nextBtn);
    }

    function getCardDataById(id) {
      const card = cards.find((item) => item.dataset.productId === String(id));
      if (!card) return null;

      return {
        id: String(card.dataset.productId || ''),
        title: card.dataset.productTitle || '',
        url: card.dataset.productUrl || '#',
        image: card.dataset.productImage || '',
        price: card.dataset.productPrice || '',
        category: card.dataset.productCategory || '',
        feature1: card.dataset.productFeature1 || '',
        feature2: card.dataset.productFeature2 || '',
        feature3: card.dataset.productFeature3 || ''
      };
    }

    function getCompareItems() {
      return getStored(compareKey);
    }

    function saveCompareItems(items) {
      setStored(compareKey, items);
    }

    function updateCompareButtons() {
      const compareItems = getCompareItems();
      const ids = compareItems.map((item) => String(item.id));

      root.querySelectorAll('[data-compare-btn]').forEach((btn) => {
        const id = btn.getAttribute('data-product-id');
        btn.classList.toggle('is-active', ids.includes(String(id)));
      });
    }

    function syncIconStates() {
      const wishlist = getStored(wishlistKey);
      const compareItems = getCompareItems();
      const compareIds = compareItems.map((item) => String(item.id));

      root.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
        const id = btn.getAttribute('data-product-id');
        btn.classList.toggle('is-active', wishlist.includes(id));
      });

      root.querySelectorAll('[data-compare-btn]').forEach((btn) => {
        const id = btn.getAttribute('data-product-id');
        btn.classList.toggle('is-active', compareIds.includes(String(id)));
      });
    }

    function closeCompareDrawer() {
      if (compareDrawer) compareDrawer.hidden = true;
    }

    function openCompareDrawer() {
      if (compareDrawer) compareDrawer.hidden = false;
    }

    function closeCompareModal() {
      if (!compareModal) return;
      compareModal.hidden = true;
      document.body.classList.remove('compare-modal-open');
    }

    function openCompareModal() {
      if (!compareModal) return;
      compareModal.hidden = false;
      document.body.classList.add('compare-modal-open');
    }

    function removeCompareItem(id) {
      const items = getCompareItems().filter((item) => String(item.id) !== String(id));
      saveCompareItems(items);
      renderCompareUI();
      syncIconStates();
    }

    function renderCompareDrawerItems(items) {
      if (!compareList) return;

      compareList.innerHTML = '';

      if (!items.length) {
        compareList.innerHTML = '<div class="equipment-compare-empty">No products selected yet.</div>';
        return;
      }

      items.forEach((item) => {
        const row = document.createElement('div');
        row.className = 'equipment-compare-item';

        row.innerHTML = `
          <div class="equipment-compare-item__media">
            ${item.image ? `<img src="${item.image}" alt="${item.title}">` : `<div class="equipment-compare-item__placeholder"></div>`}
          </div>
          <div class="equipment-compare-item__content">
            <h4>${item.title}</h4>
            <div class="equipment-compare-item__price">${item.price}</div>
          </div>
          <button type="button" class="equipment-compare-item__remove" data-remove-compare="${item.id}" aria-label="Remove item">✕</button>
        `;

        compareList.appendChild(row);
      });

      compareList.querySelectorAll('[data-remove-compare]').forEach((btn) => {
        btn.addEventListener('click', function () {
          removeCompareItem(this.getAttribute('data-remove-compare'));
        });
      });
    }

    function renderCompareTable(items) {
      if (!compareTableWrap) return;

      if (items.length < 2) {
        compareTableWrap.innerHTML = '<div class="equipment-compare-empty">Select at least 2 items to compare.</div>';
        return;
      }

      const rows = [
        {
          label: 'Category',
          values: items.map((item) => item.category || '-')
        },
        {
          label: 'Daily Rate',
          values: items.map((item) => item.price || '-')
        },
        {
          label: 'Spec 1',
          values: items.map((item) => item.feature1 || '-')
        },
        {
          label: 'Spec 2',
          values: items.map((item) => item.feature2 || '-')
        },
        {
          label: 'Spec 3',
          values: items.map((item) => item.feature3 || '-')
        }
      ];

      let headCols = '<th class="equipment-compare-table__spec">Specification</th>';
      items.forEach((item) => {
        headCols += `
          <th>
            <div class="equipment-compare-product">
              <button type="button" class="equipment-compare-product__remove" data-remove-compare-modal="${item.id}" aria-label="Remove item">✕</button>
              <a href="${item.url}" class="equipment-compare-product__image-wrap">
                ${item.image ? `<img src="${item.image}" alt="${item.title}" class="equipment-compare-product__image">` : `<div class="equipment-compare-product__placeholder"></div>`}
              </a>
              <div class="equipment-compare-product__title">${item.title}</div>
            </div>
          </th>
        `;
      });

      let bodyRows = '';
      rows.forEach((row) => {
        bodyRows += `<tr><td class="equipment-compare-table__label">${row.label}</td>`;
        row.values.forEach((value) => {
          bodyRows += `<td>${value}</td>`;
        });
        bodyRows += '</tr>';
      });

      let actionRow = '<tr><td class="equipment-compare-table__label">Actions</td>';
      items.forEach((item) => {
        actionRow += `
          <td>
            <div class="equipment-compare-actions">
              <a href="${item.url}" class="equipment-btn equipment-btn--primary">View details</a>
              <a href="tel:+18102317368" class="equipment-btn equipment-btn--secondary">Call now</a>
            </div>
          </td>
        `;
      });
      actionRow += '</tr>';

      compareTableWrap.innerHTML = `
        <div class="equipment-compare-table-scroll">
          <table class="equipment-compare-table">
            <thead>
              <tr>${headCols}</tr>
            </thead>
            <tbody>
              ${bodyRows}
              ${actionRow}
            </tbody>
          </table>
        </div>
      `;

      compareTableWrap.querySelectorAll('[data-remove-compare-modal]').forEach((btn) => {
        btn.addEventListener('click', function () {
          removeCompareItem(this.getAttribute('data-remove-compare-modal'));
        });
      });
    }

    function renderCompareUI() {
      const items = getCompareItems();

      if (compareWidget) {
        compareWidget.hidden = items.length === 0;
      }

      if (compareCount) {
        compareCount.textContent = `${items.length} item${items.length === 1 ? '' : 's'}`;
      }

      if (compareCountDrawer) {
        compareCountDrawer.textContent = items.length;
      }

      if (compareNote) {
        compareNote.textContent =
          items.length >= 2
            ? 'Ready to compare'
            : 'Select at least 2 items to compare';
      }

      if (compareNowBtn) {
        compareNowBtn.disabled = items.length < 2;
      }

      renderCompareDrawerItems(items);
      renderCompareTable(items);
      updateCompareButtons();

      if (!items.length) {
        closeCompareDrawer();
      }
    }

    function render() {
      updateVisibleSubcategories();

      const filtered = getFilteredCards();
      const total = filtered.length;
      const totalPages = Math.max(1, Math.ceil(total / perPage));

      if (state.page > totalPages) state.page = 1;

      const start = (state.page - 1) * perPage;
      const end = start + perPage;

      cards.forEach((card) => card.classList.add('is-hidden'));
      filtered.slice(start, end).forEach((card) => card.classList.remove('is-hidden'));

      if (resultsText) {
        if (total === 0) {
          resultsText.textContent = '0 machines found';
        } else {
          resultsText.textContent = `${start + 1}-${Math.min(end, total)} of ${total} machines`;
        }
      }

      renderPagination(total);
      syncIconStates();
      renderCompareUI();
      updateUrl();
      updateActiveFilterLink();
    }

    categoryButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        state.category = btn.getAttribute('data-category');
        state.categoryKey = btn.getAttribute('data-category-key') || 'all';
        state.subcategory = 'all';
        state.page = 1;
        setActive(categoryButtons, state.category, 'data-category');
        updateVisibleSubcategories();
        render();
      });
    });

    subcategoryButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-hidden-by-category')) return;

        state.subcategory = btn.getAttribute('data-subcategory');
        state.page = 1;
        setActiveSubcategory(state.subcategory);
        render();
      });
    });

    fuelButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        state.fuel = btn.getAttribute('data-fuel');
        state.page = 1;
        setActive(fuelButtons, state.fuel, 'data-fuel');
        render();
      });
    });

    root.querySelectorAll('[data-add-to-cart]').forEach((button) => {
      button.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();

        const variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;

        const originalText = this.textContent;
        this.disabled = true;
        this.textContent = 'Adding...';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });

          if (!response.ok) throw new Error('Add to cart failed');

          this.textContent = 'Added';
          setTimeout(() => {
            this.disabled = false;
            this.textContent = originalText;
          }, 1200);
        } catch (error) {
          this.disabled = false;
          this.textContent = 'Try again';
          setTimeout(() => {
            this.textContent = originalText;
          }, 1200);
        }
      });
    });

    root.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const id = this.getAttribute('data-product-id');
        let wishlist = getStored(wishlistKey);

        if (wishlist.includes(id)) {
          wishlist = wishlist.filter((item) => item !== id);
        } else {
          wishlist.push(id);
        }

        setStored(wishlistKey, wishlist);
        syncIconStates();
      });
    });

    root.querySelectorAll('[data-compare-btn]').forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const id = this.getAttribute('data-product-id');
        let compareItems = getCompareItems();
        const exists = compareItems.some((item) => String(item.id) === String(id));

        if (exists) {
          compareItems = compareItems.filter((item) => String(item.id) !== String(id));
        } else {
          const productData = getCardDataById(id);
          if (!productData) return;

          if (compareItems.length >= 3) compareItems.shift();
          compareItems.push(productData);
        }

        saveCompareItems(compareItems);
        renderCompareUI();
        syncIconStates();

        if (compareItems.length) {
          openCompareDrawer();
        }
      });
    });

    if (compareTrigger) {
      compareTrigger.addEventListener('click', function () {
        if (compareDrawer) {
          compareDrawer.hidden = !compareDrawer.hidden;
        }
      });
    }

    if (compareClear) {
      compareClear.addEventListener('click', function () {
        saveCompareItems([]);
        renderCompareUI();
        syncIconStates();
        closeCompareModal();
      });
    }

    root.querySelectorAll('[data-compare-close]').forEach((btn) => {
      btn.addEventListener('click', closeCompareDrawer);
    });

    if (compareNowBtn) {
      compareNowBtn.addEventListener('click', function () {
        const items = getCompareItems();
        if (items.length < 2) return;
        openCompareModal();
      });
    }

    root.querySelectorAll('[data-compare-modal-close]').forEach((btn) => {
      btn.addEventListener('click', closeCompareModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeCompareModal();
      }
    });

    applyStateFromUrl();
    render();
  });
});